import axios from "axios";
import { EmployeePosition, Positions, PositionsSalary } from "../types/EmployeeTypes";
import apiClient from "./apiClient";

export const getPositions = async (): Promise<Positions[]> => {
    try{
        const response = await apiClient.get('/Parameters');
        return await response.data;
    }catch (error){
        const errorMessage = (error as Error).message;
        throw new Error('Error al obtener los cargos: ' + errorMessage);
    }
};

export const getPositionsSalary = async (): Promise<PositionsSalary[]> => {
    const response = await apiClient.get<PositionsSalary[]>(`/Loads`);
    return response.data;
};

export const getPositionSalaryByProjectId = async(projectId: number): Promise<PositionsSalary[]> => {
    const response = await apiClient.get<PositionsSalary[]>(`/Loads/${projectId}`);
    return response.data;
};

// Función para agregar una nueva carga
export const addPositionsSalary = async (load: EmployeePosition): Promise<EmployeePosition> => {
    const response = await apiClient.post<EmployeePosition>(`/Loads`, load);
    return response.data;
};

// Función para actualizar una carga existente
export const updatePositionsSalary= async (load: Partial<PositionsSalary>): Promise<PositionsSalary> => {
    const response = await apiClient.put<PositionsSalary>(`/Loads`, load);
    return response.data;
};

// Función para eliminar una carga por su ID
export const deletePositionsSalary = async (idLoad: number): Promise<void> => {
    await apiClient.delete(`/Loads/${idLoad}`);
};

export const addPosition = async (position: Partial<Positions>): Promise<Positions> => {
    const response = await apiClient.post<Positions>('/Parameters', position);
    return response.data;
};

export const updatePosition = async (id: number, position: Partial<Positions>): Promise<Positions> => {
    const response = await apiClient.put<Positions>(`/Parameters/${id}`, position);
    return response.data;
};

export const deletePosition = async (id: number): Promise<void> => {
    await apiClient.delete(`/Parameters/${id}`);
};